<template>
  <div style="margin-left: 12px">
    <v-row v-if="dataExercise !== null">
      <template v-if="computedAvgPointData && computedAllAvgPointData && computedAllAvgPointData.length > 0 && !loading">
        <v-col cols="6">
          <div>Điểm trung bình {{activeFilterSubject}}</div>
          <div class="mt-3">
            <table class="tutor-study-result-table" v-if="computedAvgPointData">
              <thead>
              <!-- <tr>
                <th>
                </th>
                <th colspan="3" style="border-bottom: 1px solid #9747FF33">{{activeFilterSubject}}</th>
              </tr> -->
              <tr>
                <th style="border-bottom: 1px solid #9747FF33">
                </th>
                <th v-for="component in computedAvgPointData.component" :key="component.name">
                  {{component.name}}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>
                  <strong>Số câu đúng/Tổng số câu hỏi</strong>
                </td>
                <td v-for="component in computedAvgPointData.component" :key="component.name + 'td'">
                  <div v-if="component.name === 'BTVN'">
                    {{component.correctQuestion}}/{{component.totalQuestion}}
                  </div>
                  <div v-if="component.name === 'Số cup'" class="d-flex justify-center text-no-wrap">
                    <div class="m-auto">{{component.totalCup}}</div>
                    <div class="d-flex">
                      <img src="../../assets/cup-icon.svg" height="14" width="14" alt="" class="mt-1 ml-2">
                      <up-down-scope
                        v-if="component.compareCup && ['increase','decrease'].includes(component.compareCup) && component.comparePointCup"
                        :value="component.comparePointCup"
                        :kind="component.compareCup"
                        :percent="true"
                      ></up-down-scope>
                    </div>
                  </div>
                  <div v-if="component.name ==='Số lần phát biểu'">
                    {{component.raiseHand}}
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Điểm trung bình</strong>
                </td>
                <td>
                  <div class="d-flex justify-center">
                    <div class="my-auto">{{computedAvgPointData.component.find((e) => e.name === 'BTVN').diemTb ? computedAvgPointData.component.find((e) => e.name === 'BTVN').diemTb.toFixed(2) : '--'}}</div>
                    <up-down-scope
                      v-if="computedAvgPointData.component.find((e) => e.name === 'BTVN').compare && ['increase','decrease'].includes(computedAvgPointData.component.find((e) => e.name === 'BTVN').compare) && computedAvgPointData.component.find((e) => e.name === 'BTVN').comparePoint"
                      :value="computedAvgPointData.component.find((e) => e.name === 'BTVN').comparePoint"
                      :kind="computedAvgPointData.component.find((e) => e.name === 'BTVN').compare"
                    ></up-down-scope>
                  </div>
                </td>
                <td></td>
                <td></td>
              </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <v-col cols="6">
          Tổng điểm trung bình các lớp
          <div class="mt-3">
            <table class="tutor-study-result-table" v-if="computedAllAvgPointData.length > 0">
              <thead>
              <tr>
                <th style="border-bottom: 1px solid #9747FF33">Mã lớp</th>
                <th>Số câu đúng/tổng câu</th>
                <th>Điểm trung bình</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="classDetail in computedAllAvgPointData" :key="classDetail.classCode">
                <td>
                  <strong>{{classDetail.classCode}}</strong>
                </td>
                <td v-if="classDetail.totalQuestion">
                  {{classDetail.totalCorrectQuestion}}/{{classDetail.totalQuestion}}
                </td>
                <td class="text-center">
                  <div class="d-flex justify-center">
                    <div class="my-auto"> {{classDetail.averagePoint ? classDetail.averagePoint.toFixed(2) : '--'}}</div>
                    <up-down-scope
                      v-if="classDetail.comparePoint && ['increase','decrease'].includes(classDetail.comparePoint) && classDetail.comparePointPoint"
                      :value="classDetail.comparePointPoint"
                      :kind="classDetail.comparePoint"
                    ></up-down-scope>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </v-col>
      </template>
      <div v-else class="d-flex flex-column justify-center align-center w-100" style="margin-top: 70px">
        <img src="../../assets/close-icon.png" alt="" class="mb-2">
        <img src="../../assets/no-data-exercise.png" alt="" class="mb-5">
        <span style="color: #828282">
          Học sinh chưa có thông tin điểm
        </span>
      </div>

    </v-row>
    <note-filter-for-date v-if="computedAvgPointData && computedAllAvgPointData && computedAllAvgPointData.length > 0 && !loading" :dateTime="filterForm.dateTime"></note-filter-for-date>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import moment from 'moment/moment';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import NoteFilterForDate from '../ModalScoreDetail/NoteFilterForDate.vue';
import UpDownScope from '../ModalScoreDetail/UpDownScope.vue';

export default {
  components: { NoteFilterForDate, UpDownScope },
  name: 'ExerciseTutorTab',
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    if (this.dataExercise === null) {
      await this.getDataExerciseData();
    }
    this.loading = false;
  },
  watch: {
    filterForm: {
      deep: true,
      handler() {
        this.getDataExerciseData();
      },
    },
  },
  computed: {
    ...mapState('student_detail_bt', ['activeProgramSubjectId', 'activeFilterSubject', 'dataExercise', 'filterForm', 'studentBlendedTutorDetail']),
    computedAvgPointData() {
      return this.dataExercise.mon.find((e) => e.curriculumName === this.activeFilterSubject);
    },
    computedAllAvgPointData() {
      return this.dataExercise.classes.filter((e) => e.curriculumName === this.activeFilterSubject);
    },
  },
  methods: {
    ...mapActions('student_detail_bt', ['setDataExercise']),
    async getDataExerciseData() {
      if (this.studentBlendedTutorDetail.lms_core_user_id) {
        this.loading = true;
        const loading = this.$loading.show();
        const range = moment(this.filterForm.dateTime[0]).diff(moment(this.filterForm.dateTime[1]), 'days');
        const response = await BlendedCareRepository.getDataExerciseData({
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          // id: 1172937,
          startTime: moment(this.filterForm.dateTime[0]).format('YYYY-MM-DD'),
          endTime: moment(this.filterForm.dateTime[1]).format('YYYY-MM-DD'),
          prevStartTime: moment(this.filterForm.dateTime[0]).subtract(1 + Math.abs(range), 'd').format('YYYY-MM-DD'),
          prevEndTime: moment(this.filterForm.dateTime[0]).subtract(1, 'd').format('YYYY-MM-DD'),
          tutorSchoolLevel: this.$route.query.schoolLevel === 'secondary' ? 'secondary' : null,
          recordId: this.$route.query.schoolLevel === 'secondary' ? this.studentBlendedTutorDetail.id : null,
        });
        if (response.message === 'Success') {
          this.setDataExercise(response.data);
        }
        loading.hide();
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tutor-study-result-table {
  display: block;
  border-spacing: 0;
  width: 100%;
  max-height: 260px;
  overflow: auto;
  thead {
    position: sticky;
    top: 0;
    z-index: 10;
    tr th {
      min-width: 80px;
      text-align: center;
      padding: 8px 10px;
      background: #4D4CAC;
      color: #fff;
    }
  }
  tbody {
    tr {
      // td:first-child {
      //   background: #4D4CAC;
      //   color: #fff;
      // }
      td {
        padding: 10px;
        border-bottom: 1px solid #fff;
        text-align: center;
        background: #F9F4F4;
        color: #000;
      }
      //&:not(:last-child) {
      //  td{
      //    border-bottom: 1px solid #9747FF33;
      //  }
      //}
    }
  }
}
  @media screen and (max-width: 1440px) {
    .tutor-study-result-table {
      font-size: 12px;
      thead {
        tr th {
          padding: 8px 8px;
        }
      }
      tbody {
        tr {
          td {
            padding: 8px;
          }
        }
      }
    }
  }
</style>
